module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="trade-player-pool-table-head-container">\n	<div class="trade-player-pool-table-head table-head coach-stat-item">\n		<div class="column column-1">Opponent</div>\n		<div class="column column-2">Venues</div>\n		<div class="column column-3">Average</div>\n		<div class="column column-4">Last 3 Average</div>\n		<div class="column column-5">Last 3 Scores</div>\n	</div>\n</div>';
}
return __p;
};
